import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=06f6921e"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookingButton: require('/vercel/path0/components/elements/BookingButton.vue').default,Richtext: require('/vercel/path0/components/elements/Richtext.vue').default})
